import React, { useEffect, useState } from "react";
import { 
    Box, Button, Container, Divider, Grid, Toolbar, AppBar, 
    Typography, Menu, MenuItem, IconButton, Paper, Stack, Chip 
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ModalUnstyled } from "../modal/Modal";
import { StoreCard } from "../components/StoreCard";
import { useLocalStorage } from "../hooks/useLocalStorage";
import MultiStepForm from "../Forms/MultiStepPayFrom";
import Footer from "./homepage/components/Footer";
import { MoreVert } from "@mui/icons-material";
import { FranchiseForm } from "../Forms/FranchiseForm";
export const StoreSelect = () => {
    const { Logout, user, listStore, listFRN, updateStoreList } = useAuth();
    const [showModaladd1, setshowModaladd1] = useState(false);

    const [da, setda] = useLocalStorage('da', null);
    const [, setStore] = useLocalStorage('ds', null);
    const navigate = useNavigate();

    // Context Popover Menu State
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [modelFor, setModelFor] = useState("addStore"); // Tracks 'addStore' vs 'addFranchise'

    useEffect(() => {
        if (!user) {
            navigate("/login", { replace: true });
        }
        if (da >= 0 && da !== null) {
            navigate("/admin", { replace: true });
        }
        updateStoreList();
        // eslint-disable-next-line
    }, [da, user, navigate]);

    const cardActionHandler = async (type, storeid) => {
        setda(type);
        await setStore(storeid);
        if (da >= 0) {
            navigate("/admin", { replace: true });
        }
    };

    const handleCloseMenu = () => {
        setMenuAnchor(null);
    };

    const triggerModalWindow = (targetViewType) => {
        setModelFor(targetViewType);
        setshowModaladd1(true);
        handleCloseMenu();
    };

    // Open the franchise dashboard view (franchise.jsx) for the selected franchise.
    const openFranchiseView = (franchiseID) => {
        navigate(`/franchise/${franchiseID}`);
    };

    // Group the stores under their parent franchise so each franchise can be
    // displayed with the outlets that belong to it.
    const stores = Array.isArray(listStore) ? listStore : [];
    const franchises = Array.isArray(listFRN) ? listFRN : [];

    const storesByFranchise = stores.reduce((acc, store) => {
        const key = store.franchiseid || "__unassigned__";
        if (!acc[key]) acc[key] = [];
        acc[key].push(store);
        return acc;
    }, {});

    // Stores that don't map to any known franchise in the list.
    const knownFranchiseIds = new Set(franchises.map((f) => f.franchiseID));
    const unassignedStores = stores.filter(
        (store) => !store.franchiseid || !knownFranchiseIds.has(store.franchiseid)
    );

    const renderStoreCard = (store) => (
        <Grid item xs={12} sm={6} md={4} key={'grid-' + store.storeid}>
            <StoreCard
                key={'ss' + store.storeid}
                storeName={store.name}
                storeid={store.storeid}
                type={store.type}
                address={store.address}
                setda={setda}
                setStore={setStore}
                cardActionHandler={cardActionHandler}
            />
        </Grid>
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar position="fixed" sx={{ background: '#1a1b2f' }} elevation={2}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Typography
                        variant="h6"
                        onClick={() => { navigate("/") }}
                        sx={{ cursor: 'pointer' }}
                    >
                        MiiRA POS
                    </Typography>
                    <Box>
                        <Button
                            sx={{ background: 'tomato', color: '#fff', px: 2, py: 1 }}
                            key={'Logout-0'}
                            onClick={() => Logout()}
                        >
                            LogOut
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
                <Toolbar />

                <Container maxWidth="lg">
                    <Box sx={{ mb: 2 }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={8}>
                                <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                    STORE LIST
                                    {(da > 90) ?
                                    <IconButton
                                        size="small"
                                        onClick={(e) => setMenuAnchor(e.currentTarget)}
                                        sx={{ ml: 0.5 }}
                                    >
                                        <MoreVert fontSize="small" />
                                    </IconButton> : null}
                                </Typography>

                                <Menu
                                    anchorEl={menuAnchor}
                                    open={Boolean(menuAnchor)}
                                    onClose={handleCloseMenu}
                                    elevation={3}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    PaperProps={{ sx: { minWidth: 180, borderRadius: 2 } }}
                                >
                                    <MenuItem 
                                        onClick={() => triggerModalWindow("addFranchise")} 
                                        sx={{ gap: 1.5, fontSize: 14, color: 'primary.main', fontWeight: '500' }}
                                    >
                                        Add Franchise
                                    </MenuItem>
                                </Menu>
                            </Grid>

                            <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                <Button
                                    variant="contained"
                                    fullWidth={false}
                                    onClick={() => triggerModalWindow("addStore")}
                                >
                                    + Add Store
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider sx={{ marginBottom: "25px" }} />

                    <Box>
                        {stores.length === 0 && franchises.length === 0 ? (
                            <Typography align="center" variant="body1" color="textSecondary">
                                NO Data From Server
                            </Typography>
                        ) : (
                            <Stack spacing={4}>
                                {/* One section per franchise, listing the outlets that belong to it */}
                                {franchises.map((franchise) => {
                                    const franchiseStores = storesByFranchise[franchise.franchiseID] || [];
                                    return (
                                        <Paper
                                            key={'frn-' + franchise.franchiseID}
                                            elevation={2}
                                            sx={{ p: 2, borderRadius: 2 }}
                                        >
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                spacing={1}
                                                onClick={() => openFranchiseView(franchise.franchiseID)}
                                                sx={{
                                                    mb: 0.5,
                                                    flexWrap: 'wrap',
                                                    cursor: 'pointer',
                                                    borderRadius: 1,
                                                    p: 0.5,
                                                    '&:hover': { bgcolor: 'action.hover' },
                                                }}
                                            >
                                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                    {franchise.name}
                                                </Typography>
                                                <Chip
                                                    size="small"
                                                    label={franchise.franchiseID}
                                                    variant="outlined"
                                                />
                                                {franchise.status && (
                                                    <Chip
                                                        size="small"
                                                        color={franchise.status === 'active' ? 'success' : 'default'}
                                                        label={franchise.status}
                                                    />
                                                )}
                                                <Box sx={{ flexGrow: 1 }} />
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openFranchiseView(franchise.franchiseID);
                                                    }}
                                                >
                                                    Manage Franchise
                                                </Button>
                                            </Stack>
                                            <Grid container spacing={3}>
                                                {franchiseStores.length > 0 ? (
                                                    franchiseStores.map(renderStoreCard)
                                                ) : (
                                                    <Grid item xs={12}>
                                                        <Typography variant="body2" color="textSecondary">
                                                            No stores under this franchise yet.
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Paper>
                                    );
                                })}

                                {/* Stores not tied to any listed franchise */}
                                {unassignedStores.length > 0 && (
                                    <Box>
                                        {franchises.length > 0 && (
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                                                Other Stores
                                            </Typography>
                                        )}
                                        <Grid container spacing={3}>
                                            {unassignedStores.map(renderStoreCard)}
                                        </Grid>
                                    </Box>
                                )}
                            </Stack>
                        )}
                    </Box>

                    {/* Cleaned Modal Wrapper with Fixed Switch Rendering Expressions */}
                    <ModalUnstyled
                        shouldShow={showModaladd1}
                        onRequestClose={() => setshowModaladd1(false)}
                    >
                        {modelFor === "addStore" ? (
                            <MultiStepForm setshowModaladd={setshowModaladd1} />
                        ) : (
                            <FranchiseForm onRequestClose={() => setshowModaladd1(false)} />
                        )}
                    </ModalUnstyled>
                </Container>
            </Box>

            <Box component="footer" sx={{ py: 2, bgcolor: 'background.paper', mt: 'auto' }}>
                <Footer />
            </Box>
        </Box>
    );
};